// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-left-double-s"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16.4984 15.5355L12.9629 12L16.4984 8.46448M11.0375 15.5355L7.50195 12L11.0375 8.46448","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronLeftDoubleSIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-left-double-s',
    ref,
    icon: element,
  },
));

ChevronLeftDoubleSIcon.displayName = 'ChevronLeftDoubleSIcon';

export default ChevronLeftDoubleSIcon;
